import React from "react";
import Zoom from "react-reveal/Zoom";
//images
import craft from "../../../../../assets/images/redesign/signup-react/partners/kraft.svg";
import pg from "../../../../../assets/images/redesign/signup-react/partners/p-and-g.svg";
import uni from "../../../../../assets/images/redesign/signup-react/partners/unilever.svg";
import loreal from "../../../../../assets/images/redesign/signup-react/partners/loreal.svg";
import kelloggs from "../../../../../assets/images/redesign/signup-react/partners/kelloggs.svg";
import reckitt from "../../../../../assets/images/redesign/signup-react/partners/reckitt.svg";
import mars from "../../../../../assets/images/redesign/signup-react/partners/mars.svg";
import hallmark from "../../../../../assets/images/redesign/signup-react/partners/hallmark.svg";
import nestle from "../../../../../assets/images/redesign/signup-react/partners/nestle.svg";
import coty from "../../../../../assets/images/redesign/signup-react/partners/coty-inc-vector.svg";
import starbucks from "../../../../../assets/images/redesign/signup-react/partners/starbucks.svg";
import bei from "../../../../../assets/images/redesign/signup-react/partners/beiersdorf.svg";
import threeme from "../../../../../assets/images/redesign/signup-react/partners/3m.svg";
import blue from "../../../../../assets/images/redesign/signup-react/partners/blue-buffalo.svg";
import pepsico from "../../../../../assets/images/redesign/signup-react/partners/pepsico.svg";
import clorox from "../../../../../assets/images/redesign/signup-react/partners/clorox.svg";

function Partners() {
  return (
    <div className="pw-partners-container">
      <h1 className="pw-partners-container--header">
        Some of our amazing clients.
      </h1>
      <div className="pw-container">
        <div className="pw-row">
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={craft} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={pg} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={uni} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={loreal} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={kelloggs} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={reckitt} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={mars} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={hallmark} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={nestle} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={coty} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={starbucks} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={bei} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={threeme} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={blue} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={pepsico} alt="" />
            </div>
          </Zoom>
          <Zoom>
            <div className="pw-col-2 pw-center">
              <img src={clorox} alt="" />
            </div>
          </Zoom>
        </div>
      </div>
    </div>
  );
}

export default Partners;
